import React, { FC } from 'react';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { baseColors, withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import { homeTabClickGtm } from '@shared/lib/gtm/redesign';
import { getNavbarTabEventLabel } from '../lib/getNavbarTabEventLabel';
import { NavbarItemType } from '../model/navbar.model';
interface NavbarButtonProps {
  isActive: boolean;
  isAtTop: boolean;
  item: NavbarItemType;
}
const DesktopNavbarButton: FC<NavbarButtonProps> = ({
  isActive,
  isAtTop,
  item
}) => {
  const handleClick = () => {
    const tab = getNavbarTabEventLabel(item.label);
    if (tab) {
      homeTabClickGtm(tab);
    }
  };
  const buttonContent = <>
      <IconWrapper isAtTop={isAtTop} isActive={isActive}>
        {item.icon}
      </IconWrapper>
      <Text size="pS" color={isAtTop || isActive ? baseColors.neutral_50 : 'primary'}>
        {item.label}
      </Text>
    </>;
  if (item.href) {
    return <Link href={item.href} onClick={handleClick}>
        <NavbarButtonWrapper isActive={isActive}>{buttonContent}</NavbarButtonWrapper>
      </Link>;
  }
  return <NavbarButtonWrapper isActive={isActive}>{buttonContent}</NavbarButtonWrapper>;
};
export default DesktopNavbarButton;
type NavbarButtonWrapperProps = Pick<NavbarButtonProps, 'isActive'>;
const _exp = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.background.accent : 'transparent';
const _exp2 = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? `inset 0 0 0 9999px ${theme.colors.background.hover}` : 'none';
const _exp3 = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.background.accent : theme.colors.background.hover;
const NavbarButtonWrapper = withTheme(/*#__PURE__*/styled('li')({
  name: "NavbarButtonWrapper",
  class: "nn41xyh",
  propsAsIs: false,
  vars: {
    "nn41xyh-0": [_exp()],
    "nn41xyh-1": [_exp2()],
    "nn41xyh-2": [_exp3()]
  }
}));
type IconWrapperProps = Pick<NavbarButtonProps, 'isAtTop' | 'isActive'>;
const _exp4 = /*#__PURE__*/() => ({
  isAtTop
}) => !isAtTop ? '0.916875rem' : '1.145625rem';
const _exp5 = /*#__PURE__*/() => ({
  isAtTop,
  isActive,
  theme
}) => isAtTop || isActive ? baseColors.neutral_50 : theme.colors.icon.primary;
const _exp6 = /*#__PURE__*/() => ({
  isAtTop,
  isActive,
  theme
}) => isAtTop || isActive ? baseColors.neutral_50 : theme.colors.icon.primary;
const IconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1aww0c3",
  propsAsIs: false,
  vars: {
    "i1aww0c3-0": [_exp4()],
    "i1aww0c3-1": [_exp5()],
    "i1aww0c3-2": [_exp6()]
  }
}));

require("./DesktopNavbarButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DesktopNavbarButton.tsx");